<template>
	<div>
		<el-row :gutter="40">
			<el-col :span="12">
				<el-table :data="history.filter(data => !search || data.displayName.toLowerCase().includes(search.toLowerCase()))" style="width: 100%">
				    <el-table-column label="Предмет" prop="name">
				      <template slot-scope="scope">
				      	<el-image style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; margin-right: 5px;" :src="scope.row.image"></el-image>
				        <span>{{scope.row.displayName}}</span>
				      </template>
				    </el-table-column>
				    <el-table-column label="Опции" width="160" prop="options">
				    	<template slot="header" slot-scope="scope">
					        <el-input style="width: 100%; padding: 0;" v-model="search" size="mini" placeholder="Предмет"/>
					    </template>
				      	<template slot-scope="scope">
							<div style="text-align: right;"><el-button size="mini" icon="el-icon-right" @click="$router.push({name: 'edit item', params: {item: scope.row.item}})"></el-button></div>
				      	</template>
				    </el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<hr>
		<el-row :gutter="40">
			<el-col>
				<p>На этой странице выводится Ваша история редактирования. Состоит из списка ссылок на страницы предметов, которые были открыты в режиме редактирования, отсортированные в хронологическом порядке. Эта страница может быть полезна для навигации в случае редактирования рецептов с глубокой вложенностью ингредиентов. В шапке таблицы находится поисковое поле, фильтрующее по наименованию предмета, аналогичное полю страницы "Коллекции предметов".</p>
			</el-col>
		</el-row>	
	</div>
</template>

<script>
export default {
  	data() {
	    return {
	    	search: '',
	    };
  	},
  	computed: {
  		history: function(){
  			var self = this;
  			var history = [];
  			var userCollection = [];
	  		for (var prop in self.$store.state.userCollection) {
				userCollection = userCollection.concat(self.$store.state.userCollection[prop]);
			};
  			self.$store.state.history.forEach(function(el){
  				var item = userCollection.find(function(subEl){	
	  				return subEl.item == el.item;
	  			});
  				if (item) {
		  			history.push({
		  				displayName: item.displayName,
		  				image: item.image,
		  				item: el.item,
		  			});
		  		};
			});
			return history.reverse();
		},	
  	},
  	mounted() {
  		var self = this;
  	},	
};
</script>
